import { truthty } from 'utils/functions';

// @ts-nocheck
export const apiSuccess = (entity, payload, args) => ({
  type: entity,
  payload,
  ...args,
});

const defaultHeader = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export default function* apiRequest(
  url,
  options = defaultHeader,
  login = undefined,
  fileName = undefined,
) {
  const isFormData = options.body instanceof FormData;
  const headers = isFormData ? {} : defaultHeader.headers;
  const res = yield fetch(`${window.location.origin}/${url}`, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  })
    .then(async (response) => {
      if (fileName) {
        response.blob().then((blob) => {
          const data = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          link.click();

          return { ok: true };
        });
      } else if (response.ok) {
        const json = await response.json();
        return { ok: true, ...json };
      } else if (response.status === 401) {
        localStorage.clear();
        if (!login) {
          window.location.replace('/logout');
        }
      } else {
        const rawBody = await response.text();

        try {
          const json = rawBody ? JSON.parse(rawBody) : {};
          return {
            ok: false,
            error: true,
            errorMsg: json.errorMsg || json.message || json.error || rawBody || 'Error in request',
            ...json,
          };
        } catch (error) {
          return {
            ok: false,
            error: true,
            errorMsg: rawBody || 'Error in request',
          };
        }
      }
    })
    .catch((response) => {
      console.error(response);
      return { ok: false, message: 'Error in request' };
    });
  return res;
}

export function objectToQueryString(obj) {
  return Object.keys(obj)
    .map((k) => {
      if (truthty(obj[k])) {
        return Array.isArray(obj[k])
          ? obj[k].map((o) => `${encodeURIComponent(k)}[]=${encodeURIComponent(o)}`).join('&')
          : `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`;
      }
      return '';
    })
    .join('&');
}

export function* post(path, body) {
  const options = {
    method: 'post',
    body: JSON.stringify(body),
  };

  return yield apiRequest(path, options);
}

export function* update(path, body) {
  const options = {
    method: 'put',
    body: JSON.stringify(body),
  };

  return yield apiRequest(path, options);
}

export function* get(path, query) {
  const options = {
    method: 'get',
  };

  return yield apiRequest(`${path}?${query}`, options);
}

export function objectToFormData(obj, rootName, ignoreList) {
  const formData = new FormData();
  function appendFormData(data, root) {
    if (!ignore(root)) {
      root = root || '';
      if (data instanceof File) {
        formData.append(root, data);
      } else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          appendFormData(data[i], `${root}[${i}]`);
        }
      } else if (typeof data === 'object' && data) {
        Object.keys(data).map((key) => {
          if (data.hasOwnProperty(key)) {
            if (root === '') {
              appendFormData(data[key], key);
            } else {
              appendFormData(data[key], `${root}[${key}]`);
            }
          }
          return data;
        });
      } else if (data !== null && typeof data !== 'undefined') {
        formData.append(root, data);
      }
    }
  }

  function ignore(root) {
    return Array.isArray(ignoreList) && ignoreList.some((x) => x === root);
  }

  appendFormData(obj, rootName);

  return formData;
}
